module.exports = __webpack_public_path__ + "assets/d3d05a3bc8a2b037a020180e98952123.icon_info_small.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_info_small.svg
 ** module id = 834
 ** module chunks = 0
 **/